import React from "react";
import { Button } from "react-bootstrap";
import { UiCardTitle } from "../../../components/common/UiCardTitle";
import { UiContentCol, UiContentWr } from "../../../components/common/UiPageElements";
import { UiInput } from "../../../components/form/UiInput";

export const PurchaseTopUp = () => {
    return (
        <>
            <div className="sb-g-points">
                <UiCardTitle title="Purchase Top-up" />

                <UiContentCol>

                    <h5>Purchase points to top up your account </h5>
                    {/* <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco.</p> */}

                    <label className="sb-lbl sb-ptu">£25 <span>(1k Points)</span></label>
                    <label className="sb-lbl sb-ptu-primary">£25 <span>(1k Points)</span></label>
                    <label className="sb-lbl sb-ptu">£25 <span>(1k Points)</span></label>

                    <Button className="sb-other-amount">Other Amount</Button>

                    <hr />

                    <Button className="sb-buy-now">Buy Now</Button>

                </UiContentCol>
            </div>
        </>
    )
}